import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { parseDatePickerValue } from './datepicker-value-parser';

export function PayDateValidator(holidays: any[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // task 12070
    // date cannot land on a holiday or sunday
    const value = control.value ? parseDatePickerValue(control.value) : null;

    if (!value || !(value instanceof Date)) {
      return { required: true };
    }
    let holiday = false;
    holidays.forEach(x => {
      const d = new Date(x);
      if (
        d.getFullYear() == value.getFullYear() &&
        d.getDate() == value.getDate() &&
        d.getMonth() == value.getMonth()
      ) {
        holiday = true;
      }
    });

    // Task 12496 - date cannot be before today
    const today = new Date();
    // strip time component off
    const c = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    if (value < new Date(c)) {
      return { past: true };
    }
    if (holiday) {
      return { holiday: true };
    } else if (value.getDay() == 0) {
      return { sunday: true };
    }

    return null;
  };
}
